import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Button } from "react-bootstrap";
import { Navigate, useParams, useNavigate } from "react-router-dom";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWorkLevelTypeData,
  selectWorkLevel,
} from "../../redux/actions/workLevelTypeAction";
import { fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchJobType, selectJobType } from "../../redux/actions/jobTypeAction";
import {
  fetchWorkLocationTypeData,
  selectLocationType,
  selectWorkLocation,
} from "../../redux/actions/workLLocationTypeAction";
import {
  fetchDesignation,
  selectDesignation,
} from "../../redux/actions/designationAction";
import {
  fetchSalaryType,
  selectSalaryType,
} from "../../redux/actions/salaryTypeAction";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import CRHeader from "../../components/header/CRHeader";

const EditJobs = () => {
  const { JobId } = useParams();
  console.log("JobId", JobId);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const sessionId = localStorage.getItem("sessionId");
  const companyType = localStorage.getItem("userType");
  const companyUId = localStorage.getItem("userUID");

  const [images, setImages] = useState([]);

  const [display, setDisplay] = useState(false);

  const [minimumSalary, setMinimumSalary] = useState("");
  const [maximumSalary, setMaximumSalary] = useState("");
  const [currency, setCurrency] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [requirement, setRequirement] = useState("");
  const [jobDescription, setjobDescription] = useState("");

  const [salaryData, setsalaryData] = useState([]);
  const [salaryDataSearch, setSalaryDataSearch] = useState("");
  const [salaryId, setsalaryId] = useState(null);

  const [designationData, setDesignationData] = useState([]);
  const [designationId, setDesignationId] = useState(null);
  console.log("designationId", designationId);

  const [workLocationData, setWorkLocationData] = useState([]);
  const [WorkLocationSearch, setWorkLocationSearch] = useState("");
  const [workLocationId, setWorkLocationId] = useState(null);
  const [JobTypeSearchId, setjobTypeSearchId] = useState(null);

  const [workTypeData, setWorkTypeData] = useState([]);
  const [WorkTypeSearch, setWorkTypeSearch] = useState("");
  const [workTypeId, setWorkTypeId] = useState(null);

  const [jobTypeData, setJobTypeData] = useState([]);
  const [jobTypeId, setJobTypeId] = useState(null);

  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState("");

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setImages(files);
  };

  const removeImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };

  const [jobData, setJobData] = useState([]);

  const getJobDetail = () => {
    axios
      .get(`/Job/GetJobDetails?JobId=${JobId}`)
      .then((response) => {
        const res = response.data.responseData;
        setJobData(res);
        console.log("edit data", res);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.log(error);
        } else {
          console.log(error);
        }
      });
  };

  useEffect(() => {
    getJobDetail();
  }, []);
  console.log("jobData", jobData);

  const handleSubmit = async () => {
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      compType: companyType,
      compUid: companyUId,
      cityId: cityListSearch,
      jbTypId: jobTypeSearch,
      workLevelType: workLevelId,
      workLocationType: workLocationSearch,
      designationId: designationSearch,
      salaryTypeId: salaryTypeSearch,
      minSalary: minimumSalary,
      maxSalary: maximumSalary,
      currency: currency,
      title: jobTitle,
      description: jobDescription,
      requirement: requirement,
      jobId: JobId,
    };
    console.log("edit job data", body);

    if (
      cityId === "" ||
      jobTypeId === "" ||
      workLevelId === "" ||
      workLocationId === "" ||
      designationId === "" ||
      salaryId === "" ||
      minimumSalary === "" ||
      maximumSalary === "" ||
      requirement === "" ||
      currency === "" ||
      jobTitle === "" ||
      jobDescription === ""
    ) {
      toast.error("Please fill all the required fields");
    } else {
      try {
        const res = await axios.post("/Job/EditJob", body);
        console.log("gashgdjdgsa", res);
        toast.success(res.data.message);
        navigate("/viewJobs");
        setSalaryTypeSearch();
        setDesignationSearch("");
        setjobDescription("");
        setworkLocationSearch("");
        setworkLevelSearch("");
        setjobTypeSearch("");
        setcityListSearch("");
        setMinimumSalary("");
        setMaximumSalary("");
        setJobTitle("");
        //   AllJobList(page);
        //   closeModal();
      } catch (e) {
        if (e.response && e.response.status === 404) {
          toast.warning(e.response.data.message);
        } else {
          toast.warning(e.response.data.message);
        }
      }
    }
  };

  useEffect(() => {
    if (jobData) {
      setJobTitle(jobData?.title);
      setCurrency(jobData?.currency);
      setMinimumSalary(jobData?.minSalary);
      setMaximumSalary(jobData?.maxSalary);
      setsalaryId(jobData?.salaryTypeId);
      // setSalaryDataSearch(jobData?.salaryTypeName);
      setDesignationId(jobData?.designationId);
      // setDesignationSearch(jobData?.designationName);
      setWorkLocationId(jobData?.workLocationType);
      // setWorkLocationSearch(jobData?.workLocationType);
      setworkLevelId(jobData?.workLevelType);
      // setWorkTypeSearch(jobData?.workLevelTypename);
      setJobTypeId(jobData?.jbTypId);
      setjobTypeSearchId(jobData?.jbTypId);
      // setJobTypeSearch(jobData?.jbTypId);
      setCityId(jobData?.cityId);
      // setCitySearch(jobData?.cityId);
      setRequirement(jobData?.requirement);
      setjobDescription(jobData?.description);
    }
  }, [jobData]);

  // ...............................Work Level Dropdown.......................................
  // Fetch work level data on component mount
  const [workLevelSearch, setworkLevelSearch] = useState("");
  const [workLevelId, setworkLevelId] = useState("");

  const { workLevelList, selectedworkLevelId } = useSelector(
    (state) => state.workLevelType
  );
  // console.log("Work Level", workLevelList, selectedworkLevelId);

  useEffect(() => {
    dispatch(fetchWorkLevelTypeData());
  }, [dispatch]);

  const handleWorkLevel = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectWorkLevel(selectedOption.value));
      setworkLevelId(selectedOption.value);
      // setworkLevelSearch(selectedOption.value);
    }
  };

  // ...............................Work Level Dropdown.......................................

  // Fetch work location data on component mount
  const [workLocationSearch, setworkLocationSearch] = useState("");

  const { workLocation, selectedCategoryId } = useSelector(
    (state) => state.workLocationType
  );

  useEffect(() => {
    dispatch(fetchWorkLocationTypeData());
  }, [dispatch]);

  const handleWorkLoc = (selectedOption) => {
    console.log("selectedOption", selectedOption);

    if (selectedOption) {
      // dispatch(selectWorkLocation(selectedOption.value));
      setworkLocationSearch(selectedOption.value);
    }
  };

  // ...............................Designation Dropdown.......................................
  const [designationSearch, setDesignationSearch] = useState("");

  const { designationList, selectedDesignationId } = useSelector(
    (state) => state.designation
  );
  // console.log('DESIGNATION',designationList,selectedDesignationId);

  useEffect(() => {
    dispatch(fetchDesignation());
  }, [dispatch]);

  const handleDesignation = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectDesignation(selectedOption.value));
      setDesignationSearch(selectedOption.value);
    }
  };
  // ...............................Designation Dropdown.......................................

  // ...............................Salary Dropdown.......................................
  const [salaryTypeSearch, setSalaryTypeSearch] = useState("");

  const { salaryTypeList, selectedSalaryTypeId } = useSelector(
    (state) => state.salaryType
  );
  // console.log('salary Type',salaryTypeList,selectedSalaryTypeId);

  useEffect(() => {
    dispatch(fetchSalaryType());
  }, [dispatch]);

  const handleSalaryType = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectSalaryType(selectedOption.value));
      setSalaryTypeSearch(selectedOption.value);
    }
  };
  // ...............................Salary Dropdown.......................................

  // ...............................Job Type Dropdown.......................................
  // Fetch jobtype data on component mount
  const [jobTypeSearch, setjobTypeSearch] = useState("");
  const { jobTypeList, selectedJobTypeId } = useSelector(
    (state) => state.jobType
  );
  // console.log('job type',jobTypeList,selectedJobTypeId);

  useEffect(() => {
    dispatch(fetchJobType());
  }, [dispatch]);

  const handleJobType = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectJobType(selectedOption.value));
      setjobTypeSearch(selectedOption.value);
    }
  };
  // ...............................Job Type Dropdown.......................................

  // ...............................City Dropdown.......................................
  // Fetch city data on component mount
  const [cityListSearch, setcityListSearch] = useState("");
  const { cityList, selectedcityId } = useSelector((state) => state.cities);
  // console.log('cityyy',cityList,selectedcityId);

  useEffect(() => {
    dispatch(fetchCityData());
  }, [dispatch]);

  const handleCitySelect = (selectedOption) => {
    if (selectedOption) {
      // dispatch(selectCity(selectedOption.value));
      setcityListSearch(selectedOption.value);
    }
  };

  // ...............................City Dropdown.......................................

  return (
    <>
      <div className="main-container">
        <div className="content-wrapper">
          <div className="title delete-title">
            <h1>
              <span className="orange-box"></span> Edit Job
            </h1>
          </div>

          <div className="card Alertcard PostCard pt-3">
            <div className="post-job-details-form p-0">
              <div className="post-form-row my-0">
                <div className="post-form-group">
                  <label htmlFor="about">
                    Job Title <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={jobTitle}
                    onChange={(e) => setJobTitle(e.target.value)}
                  />
                  {display && !jobTitle ? (
                    <span className="error_msg_lbl">Enter Job Title</span>
                  ) : null}
                </div>

                <div className="post-form-group">
                  <label htmlFor="about">
                    Currency <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={currency}
                    onChange={(e) => setCurrency(e.target.value)}
                  />
                  {display && !currency ? (
                    <span className="error_msg_lbl">Enter Currency</span>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="post-job-details-form p-0">
              <div className="post-form-row my-0">
                <div className="post-form-group">
                  <label htmlFor="about">
                    Minimum Salary <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={minimumSalary}
                    onChange={(e) => setMinimumSalary(e.target.value)}
                  />
                  {display && !minimumSalary ? (
                    <span className="error_msg_lbl">Enter Minimum Salary</span>
                  ) : null}
                </div>

                <div className="post-form-group">
                  <label htmlFor="about">
                    Maximum Salary <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    value={maximumSalary}
                    onChange={(e) => setMaximumSalary(e.target.value)}
                  />
                  {display && !maximumSalary ? (
                    <span className="error_msg_lbl">Enter Maximum Salary</span>
                  ) : null}
                </div>
              </div>

              {/* ....................... 3 Row ......................... */}
              {/* ........Salary Type........ */}

              <div className="post-form-row my-0">
                <div className="post-form-group">
                  <label htmlFor="about">
                    Salary Type <span className="text-danger">*</span>
                  </label>
                  <ReactSelect
                    options={salaryTypeList}
                    onChange={handleSalaryType}
                    value={
                      salaryTypeList.find(
                        (option) => option.value === salaryTypeSearch
                      ) || null
                    }
                    onInputChange={(inputValue) => {
                      setSalaryDataSearch(inputValue);
                    }}
                    placeholder="Select Location Type"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />

                  {display && !salaryTypeSearch ? (
                    <span className="error_msg_lbl">Select Salary Type </span>
                  ) : null}
                </div>
                {/* ........Designation........ */}

                <div className="post-form-group">
                  <label htmlFor="about">
                    Designation <span className="text-danger ms-2">*</span>
                  </label>

                  <ReactSelect
                    options={designationList}
                    onChange={handleDesignation}
                    value={
                      designationList.find(
                        (option) => option.value === designationSearch
                      ) || null
                    }
                    placeholder="Select Designation Type"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  // onInputChange={(inputValue) => {
                  //   setDesignationSearch(inputValue);
                  // }}
                  // invalid={display && designationSearch === ""}
                  />
                  {display && !designationSearch ? (
                    <span className="error_msg_lbl">Select Designation </span>
                  ) : null}
                </div>
              </div>

              {/* ....................... 4 Row ........................ */}
              {/* ........Work level type........ */}
              <div className="post-form-row my-0">
                <div className="post-form-group">
                  <label htmlFor="about">
                    Work level type <span className="text-danger ms-2">*</span>
                  </label>
                  <ReactSelect
                    options={workLevelList}
                    onChange={handleWorkLevel}
                    value={
                      workLevelList.find(
                        (option) => option.value === workLevelId
                      ) || null
                    }
                    placeholder="Select Work Level"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                    onInputChange={(inputValue) => {
                      setWorkTypeSearch(inputValue);
                    }}
                    invalid={display && workLevelId === ""}
                  />
                  {display && !workTypeId ? (
                    <span className="error_msg_lbl">
                      Select Work level type{" "}
                    </span>
                  ) : null}
                </div>

                {/* ........Work location type........ */}

                <div className="post-form-group">
                  <label htmlFor="about">
                    Work location type{" "}
                    <span className="text-danger ms-2">*</span>
                  </label>

                  <ReactSelect
                    options={workLocation}
                    onChange={handleWorkLoc}
                    value={
                      workLocation.find(
                        (option) => option.value === workLocationSearch
                      ) || null
                    }
                    placeholder="Select Location Type"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  />
                  {display && !workLocationSearch ? (
                    <span className="error_msg_lbl">
                      Select Work location type{" "}
                    </span>
                  ) : null}
                </div>
              </div>

              {/* ....................... 5 Row ........................ */}
              <div className="post-form-row my-0">
                {/* ........ Job type........ */}
                <div className="post-form-group">
                  <label htmlFor="about">
                    Job type <span className="text-danger ms-2">*</span>
                  </label>
                  <ReactSelect
                    options={jobTypeList}
                    onChange={handleJobType}
                    value={
                      jobTypeList.find(
                        (option) => option.value === jobTypeSearch
                      ) || null
                    }
                    placeholder="Select JobType"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                  // onInputChange={(inputValue) => {
                  //   setJobTypeSearch(inputValue);
                  // }}
                  // invalid={display && jobTypeSearch === ""}
                  />
                  {display && !jobTypeSearch ? (
                    <span className="error_msg_lbl">Select Job type </span>
                  ) : null}
                </div>

                {/* ........ City ........ */}
                <div className="post-form-group">
                  <label htmlFor="about">
                    City<span className="text-danger">*</span>
                  </label>

                  <ReactSelect
                    options={cityList}
                    onChange={handleCitySelect}
                    value={
                      cityList.find(
                        (option) => option.value === cityListSearch
                      ) || null
                    }
                    placeholder="Select city"
                    styles={customStyles}
                    classNamePrefix="react-select"
                    className="form-control"
                    onInputChange={(inputValue) => {
                      setCitySearch(inputValue);
                    }}
                    invalid={display && citySearch === ""}
                  />
                  {display && !cityListSearch ? (
                    <span className="error_msg_lbl">Select City </span>
                  ) : null}
                </div>
              </div>
            </div>

            <div className="post-job-form">
              <div className="post-form-group">
                <label htmlFor="job-title" className="post-form-label mt-0">
                  Requirement<span>*</span>
                </label>
                <textarea
                  id="job-requirement"
                  className="post-description-input"
                  placeholder="Type the job requirement here..."
                  value={requirement}
                  onChange={(e) => setRequirement(e.target.value)}
                ></textarea>
                {display && !requirement ? (
                  <span className="error_msg_lbl">Enter requirement</span>
                ) : null}
              </div>
            </div>

            <div className="post-job-description py-0">
              <label htmlFor="job-description" className="post-form-label mt-0">
                Job Description <span>*</span>
              </label>
              <textarea
                id="job-description"
                className="post-description-input"
                placeholder="Type the job description here..."
                value={jobDescription}
                onChange={(e) => setjobDescription(e.target.value)}
              ></textarea>
              {display && !jobDescription ? (
                <span className="error_msg_lbl">Enter Job Description</span>
              ) : null}
            </div>

            <Button 
             className="mainBtn apply-job mb-3 mt-2"
             onClick={handleSubmit}  >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditJobs;
